import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { string, oneOf, func } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';
import { SAMDualPathTooltip } from './SAMDualPathTooltip';
import { ProductAddOnsPod } from '../../common/product-add-ons-pod';

const SAMDualPath = ({
  channel,
  itemId,
  onChange,
  modelNumber,
}) => {
  const [checked, setChecked] = useState(false);
  const tooltipButtonRef = useRef(null);
  const skuType = 'Special Order';
  const baseSamUrl = 'https://sam.fit.homedepot.com/';
  const samUrl = baseSamUrl + `?sku=${itemId}&skuType=${skuType}&modelNumber=${modelNumber}&leadSource=PIP`;

  const classes = classNames({
    bttn: true,
    'bttn--atc': true,
    'buybox__add-on__schedule-a-measure': true,
    'u--hide': !checked
  });

  const handleChange = (evt) => {
    LIFE_CYCLE_EVENT_BUS.trigger('SAM-dual-path.change', { isOptedIn: !checked, itemId });
    onChange(evt, { data: { itemId } });
    setChecked(!checked);
  };

  useEffect(() => {
    const tippy = tooltipButtonRef?.current?._tippy;
    if (tippy && !checked) tippy.hide();
  }, [checked]);

  return (
    <>
      <ProductAddOnsPod
        channel={channel}
        heading="Get Expert In-Home Installation"
        subHeading="A local pro will take care of the job for you."
        icon="use-and-care-manual.svg"
        iconHeight={36}
        onChange={handleChange}
        tooltip={(
          <SAMDualPathTooltip
            channel={channel}
            ref={tooltipButtonRef}
          />
        )}
        userOptions={[
          {
            id: 'item ID',
            value: 'SAM-dual-path',
            checked,
            label: 'Add In-Home Installation'
          }
        ]}
      >
        <Button
          className={classes}
          href={samUrl}
          tag="a"
          target="_blank"
        >Schedule a Measure
        </Button>
      </ProductAddOnsPod>
    </>
  );
};

SAMDualPath.displayName = 'ProductAddOns-SAMDualPath';

SAMDualPath.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  itemId: string.isRequired,
  onChange: func.isRequired,
  modelNumber: string.isRequired,
};

SAMDualPath.defaultProps = {
  channel: 'desktop',
};

export { SAMDualPath };